import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, take, takeUntil } from 'rxjs';
import { RepoContactHorsesDto, SaleHorseRepoContactDto, SaleHorseRepoContactRequestDto, SaleHorseRepoContactResponseDto } from '../../models/sales/sale-contacts.model';
import { SaleHorse, SaleHorseTableFields } from '../../models/sales/sale-horse.model';
import { AuthService } from '../../services/auth.service';
import { SalesService } from '../../services/sales.service';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { ToastService } from '../../shared-new/services/toast.service';
import { SalesFacade } from '../../shared-new/store/sales/sales.facade';
import { ContactHorsesListDataSource } from './contact-horses.datasource';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpErrorHandlerService } from '../../services/http-error-handler.service';
import { HttpErrorRoot } from '../../models/common/http-error.model';
import { RepocontactEditComponent } from '../../repo-business/repocontact-edit/repocontact-edit.component';
import { RepoContact } from '../../models/repo-business/repo-business.model';
import { RepoBusinessService } from '../../shared-new/services/repo-business.service';
import { LookupModel } from '../../shared/search-dropdown/search-dropdown.component';
import { MatRadioChange } from '@angular/material/radio';

@Component({
  selector: 'app-sale-horse-repo-contact-edit',
  templateUrl: './sale-horse-repo-contact-edit.component.html',
  styleUrls: ['./sale-horse-repo-contact-edit.component.scss']
})
export class SaleHorseRepoContactEditComponent extends BaseUnsubscribeComponent implements OnInit {

  public _contact: RepoContact;
  private _repoContact: SaleHorseRepoContactDto;
  @Input() public set contact(value: SaleHorseRepoContactDto) {
    this._repoContact = value;
    this._contact = value;
  }
  public get contact(): SaleHorseRepoContactDto {
    return this._repoContact;
  }
  @Input() public saleId: number;
  public saleHorseRepoContactHorses: SaleHorseRepoContactResponseDto[] = [];
  public dataSource: ContactHorsesListDataSource;
  @ViewChild(MatSort) sort: MatSort;
  autocompletePlacholder: string = '';
  lotOrHipText: string = '';
  filter: string = '';
  hasHorseSelectionError: boolean = false;
  public saleHorses: SaleHorse[] = [];
  private _allSaleHorses: SaleHorse[] = [];
  @Input() public set allSaleHorses(value: SaleHorse[]) {
    this._allSaleHorses = JSON.parse(JSON.stringify([...value])) as SaleHorse[];
  }
  public get allSaleHorses(): SaleHorse[] {
    return this._allSaleHorses;
  }
  isHorseSelectionModel: boolean = false;
  isShowSearchDropDown: boolean = false;
  public selectedIdsSet = new Set<number>();
  public isPopupDirty: boolean = false;
  public isUSA: boolean = false;
  public saleHorseTableFields = SaleHorseTableFields;
  public allContacts: LookupModel[] = [];
  public formMode: string = 'Existing';
  link: string = '';
  copySuccess: boolean = false;
  @ViewChild('linkInput') linkInput!: ElementRef;
  @ViewChild(RepocontactEditComponent, { static: false }) contactEdit!: RepocontactEditComponent;
  public columns = [
    'lotNumber',
    'horseName',
    'horseAgeCategoryName',
    'consignor',
    'action'
  ];
  public displayedColumns$ = new BehaviorSubject(this.columns);
  constructor(public readonly modal: NgbActiveModal,
    private readonly salesService: SalesService,
    private readonly salesFacade: SalesFacade,
    private readonly authService: AuthService,
    private readonly spinnerService: NgxSpinnerService,
    private readonly httpErrorHandler: HttpErrorHandlerService,
    private readonly repoBusinessService: RepoBusinessService,
    private toastService: ToastService) {
    super();
    this.authService
      .getMemberLotOrHipText()
      .pipe(take(1))
      .subscribe((text) => {
        this.lotOrHipText = text;
        this.autocompletePlacholder = `Type ${this.lotOrHipText}, Horse name or DAM name to select...`;
      });

    this.authService.IsMemberFromUSA().pipe(takeUntil(this.unsubscribe$)).subscribe((isUSA) => {
      this.isUSA = isUSA;
    });
  }

  private filteredSaleHorsesForSelection() {
    const existingHorseIds = this.saleHorseRepoContactHorses.map(h => h.horseId);
    this.saleHorses = this.allSaleHorses.filter(h => !existingHorseIds.includes(h.horseId));
  }
  private editedContact: SaleHorseRepoContactDto = null;
  ngOnInit(): void {
    if (this.contact && this.contact.repoContactId > 0) {
      if (!this.editedContact) {
        this.editedContact = this.contact;
      }
      this.formMode = 'Existing';
    } else {
      this.formMode = 'New';
    }
    this.loadDataSourceForQuickSearch();


  }
  onSelectionChange(event: MatRadioChange) {
    if (event.value === 'New') {
      this.setFormStateNewInitial();
    } else if (event.value === 'Existing') {
      if (this._repoContact && this._repoContact.repoContactId === 0) {
        this._repoContact = this.editedContact;
      }
      if (this._repoContact !== null) {
        this.contact = this._repoContact;
        this.loadContactHorses(this.contact.repoContactId);
        this.allContacts = this.allContacts.map((c) => {
          if (c.id == this.contact.repoContactId) {
            c.selected = true;
          } else {
            c.selected = false;
          }
          return c;
        });
      }
    }
  }
  public get selectedContactName(): string {
    return this.allContacts?.find(c => c.selected)?.name ?? '';
  }
  private setFormStateNewInitial() {
    var contact = { repoContactId: 0 } as SaleHorseRepoContactDto;
    this.contact = contact;
    this.saleHorseRepoContactHorses = [];
    this.dataSource = new ContactHorsesListDataSource(this.saleHorseRepoContactHorses || [], this.sort, false, this.dataSource?.infiniteScrollLevel);
    this.allContacts = this.allContacts.map((c) => { c.selected = false; return c; });
    this.filteredSaleHorsesForSelection();
  }
  private loadDataSourceForQuickSearch() {

    this.repoBusinessService.getContactsByRepoBusinessId().pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
      const result = [...res];
      this.allContacts = result.map((item) => {
        return {
          id: item.repoContactId,
          name: `${item.salutation || ''} ${item.firstName} ${item.lastName}`,
          altName: item.repoBusiness?.businessName,
          selected: item.repoContactId == this._contact.repoContactId ? true : false
        } as LookupModel
      });
      const currentContact = this.allContacts.find(c => c.selected);
      if (currentContact) {
        this.loadContactHorses(currentContact.id);
      } else {
        this.loadContactHorses(this.contact.repoContactId);
      }
      this.isShowSearchDropDown = true;

    }, (err) => this.httpErrorHandler.ShowErrorMessage(err));

  }
  handleSelection(event: LookupModel) {
    if (event) {
      this.repoBusinessService.getContactById(event.id).pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
        this._contact = res;
        this.loadContactHorses(this._contact.repoContactId);
      }, (err) => this.httpErrorHandler.ShowErrorMessage(err));
    } else {
      this.setFormStateNewInitial();
    }
  }


  filterHorses() {
    const query = this.filter;
    if (query) {
      this.filterList(query);
    } else {
      const existingHorseIds = this.saleHorseRepoContactHorses.map(h => h.horseId);
      this.saleHorses = this.allSaleHorses.filter(h => !existingHorseIds.includes(h.horseId));
    }
  }

  private filterList(query: string) {
    this.saleHorses = this.saleHorses.filter((saleHorse) => {
      const hasLotNumber = saleHorse.lotNumber.toString().includes(query);
      const hasDamName = saleHorse.dam
        .toString()
        .toLowerCase()
        .includes(query.toLowerCase());
      const hasHorseName = saleHorse.horseName
        .toString()
        .toLowerCase()
        .includes(query.toLowerCase());
      return !!(hasLotNumber || hasDamName || hasHorseName);
    });
  }

  public AddNewHorses() {
    this.spinnerService.show();

    setTimeout(() => {
      this.isHorseSelectionModel = true;
      this.selectedIdsSet = new Set<number>();

      const existingHorseIds = this.saleHorseRepoContactHorses.map(h => h.horseId);
      this.saleHorses = this.allSaleHorses?.filter(
        h => !existingHorseIds.includes(h.horseId)
      );
      this.saleHorses.forEach(h => h.isSelected = false);
      this.onCheckboxChange();

      const query = this.filter;
      if (query) {
        this.filterList(query);
      }

      this.autocompletePlacholder =
        'Type HIP, Horse name or DAM name to select...';

      // ✅ Hide spinner *after* work is done
      this.spinnerService.hide();
    }, 50); // You can increase delay if needed (e.g., 200)
  }


  public AddSelectedHorses(): void {
    const selectedHorses = this.saleHorses.filter(h => this.selectedIdsSet.has(h.horseId));
    this.onHorsesSelection(selectedHorses);
    this.isHorseSelectionModel = false;
  }


  onHorsesSelection(horses: SaleHorse[]): void {
    const newContactHorses = horses.map((horse) => {
      return {
        horseId: horse.horseId,
        horseName: horse.horseName,
        lotNumber: horse.lotNumber,
        horseAgeCategoryName: horse.horseAgeCategoryName,
        sire: horse.sire,
        dam: horse.dam,
        consignor: horse.consignor,
        saleHorseRepoContactId: 0,
        saleHorseId: horse.saleHorseId,
        repoContactId: this._contact.repoContactId,
        saleId: this.saleId,
      } as SaleHorseRepoContactResponseDto;
    });
    this.saleHorseRepoContactHorses = [...this.saleHorseRepoContactHorses, ...newContactHorses];
    this.dataSource = new ContactHorsesListDataSource(this.saleHorseRepoContactHorses || [], this.sort, false, this.dataSource?.infiniteScrollLevel);
    if (this.saleHorseRepoContactHorses.length > 0) {
      this.hasHorseSelectionError = false;
    }
  }

  DeleteHorse(horse: SaleHorseRepoContactResponseDto): void {
    this.saleHorseRepoContactHorses = this.saleHorseRepoContactHorses.filter(h => h.horseId !== horse.horseId);
    this.dataSource = new ContactHorsesListDataSource(this.saleHorseRepoContactHorses || [], this.sort, false, this.dataSource?.infiniteScrollLevel);
    const existingHorseIds = this.saleHorseRepoContactHorses.map(h => h.horseId);
    this.saleHorses = this.allSaleHorses.filter(h => !existingHorseIds.includes(h.horseId));
    if (horse.saleHorseRepoContactId > 0) {
      this.salesService.deleteSaleHorseRepoContact(this.saleId, horse.saleHorseRepoContactId).pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
        if (res) {
          this.isPopupDirty = true;
          this.toastService.success('Horse deleted successfully', "Success!");
        }
      }, (err) => this.httpErrorHandler.ShowErrorMessage(err));
    }
  }

  public dismissPopup(): void {
    if (this.isPopupDirty) {
      this.modal.close(true);
    } else {
      this.modal.dismiss();
    }
  }

  public trackByIndex(index: number, contact: SaleHorseRepoContactResponseDto): number {
    return index;
  }

  private loadContactHorses(repoContactId: number): void {
    if (repoContactId > 0) {
      this.salesService.getRepoContactHorsesBySaleId(this.saleId, repoContactId)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((res) => {
          if (res) {
            this.saleHorseRepoContactHorses = res || [];
            this.filteredSaleHorsesForSelection();
            setTimeout(() => {
              this.dataSource = new ContactHorsesListDataSource(this.saleHorseRepoContactHorses || [], this.sort);
            }, 100);
          }
        }, (err) => this.httpErrorHandler.ShowErrorMessage(err));
    }
  }
  public onTableScroll() {
    this.dataSource?.onScroll();
  }
  public isAllSelected(): boolean {
    const numSelected = this.selectedIdsSet.size;
    const numRows = this.saleHorses.length;
    return numSelected === numRows;
  }

  public IsDisableAdd(): boolean {
    const numSelected = this.selectedIdsSet.size;
    return !(numSelected > 0);
  }
  masterToggle($event: MatCheckboxChange): void {
    const isChecked = $event.checked;
    this.saleHorses.forEach(row => {
      row.isSelected = isChecked;
    });
    this.onCheckboxChange();
  }

  onCheckboxChange(): void {

    const filtered = [...this.saleHorses];

    // Step 1: Build a map of isSelected states from filteredData
    const selectionMap = new Map<number, boolean>();
    filtered.forEach(row => selectionMap.set(row.horseId, row.isSelected));

    // Step 2: Apply selection state to full data list
    filtered.forEach(row => {
      if (selectionMap.has(row.horseId)) {
        row.isSelected = selectionMap.get(row.horseId)!;
      }
    });


    // Step 3: Update selectedIdsSet from updated full data
    const selected = filtered
      .filter(row => row.isSelected)
      .map(row => row.horseId);

    this.selectedIdsSet = new Set(selected);

  }

  public sortTableOnHorse(sortOn: string) {
    this.dataSource.setSortOn(sortOn);
  }

  async copyLink() {
    try {
      await navigator.clipboard.writeText(this.link);
      this.copySuccess = true;
      setTimeout(() => this.copySuccess = false, 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
      this.fallbackCopyTextToClipboard();
    }
  }

  private fallbackCopyTextToClipboard() {
    const inputElement = this.linkInput.nativeElement as HTMLInputElement;
    inputElement.select();
    inputElement.setSelectionRange(0, 99999);
    try {
      document.execCommand('copy');
      this.copySuccess = true;
      setTimeout(() => this.copySuccess = false, 2000);
    } catch (err) {
      console.error('Fallback copy failed:', err);
      alert('Failed to copy the link. Please copy it manually.');
    } finally {
      inputElement.setSelectionRange(0, 0);
    }
  }

  public saveContact(): void {

    const contact = this.contactEdit.getFormData();
    if (contact) {
      const horses = this.saleHorseRepoContactHorses.map((horse) => {
        return {
          horseId: horse.horseId,
          repoContactId: contact.repoContactId,
          saleHorseId: horse.saleHorseId,
          saleHorseRepoContactId: horse.saleHorseRepoContactId,
          saleId: this.saleId,
        } as RepoContactHorsesDto;
      })
      if (horses.length == 0) {
        this.hasHorseSelectionError = true;
        return;
      }
      const request = {
        ...contact,
        horses: horses
      } as SaleHorseRepoContactRequestDto;
      this.salesService.saveSaleHorseRepoContact(this.saleId, request)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe({
          next: (res) => {
            if (res) {
              this.toastService.success('Contact saved successfully', "Success!");
              this.modal.close(res);
            }
          },
          error: (err: HttpErrorRoot) => {
            this.httpErrorHandler.ShowErrorMessage(err);
          }
        });

    }
  }

}
